// extracted by css-extract-rspack-plugin
export default {"templateVars":"variables-module__templateVars__BKsXs"};